import type { IPropertyBag } from '@deity-io/di-data-basics';
import { Icon, Modal } from '@deity-io/portal-ui';
import { EntityNameDescriptionFields } from 'components/FormFields';
import { useFormik } from 'formik';
import type { FC } from 'react';
import { useEffect } from 'react';
import { GetPackageVersionContentInfoDocument, useCreateMockDataMutation } from 'services/graphql/generated/hooks';
import { v4 } from 'uuid';
import * as Yup from 'yup';

interface CreateEditMockDataModalProps {
  isOpen?: boolean;
  packageVersionUuid: string;
  setOpenState: (state: boolean) => void;
  onConfirm: () => void;
  source?: IPropertyBag;
  data: string;
  modelUuid?: string;
  endpointUuid?: string;
  mappingUuid?: string;
}

export interface CreateEditStructureInput {
  name: string;
  description: string;
}

export const CreateStructureInputSchema = Yup.object().shape({
  name: Yup.string().min(1, 'Too short').max(100, 'Too long'),
  description: Yup.string().min(2, 'Too short').max(255, 'Too long')
});

export const CreateEditMockDataModal: FC<CreateEditMockDataModalProps> = ({
  isOpen = false,
  setOpenState,
  onConfirm,
  packageVersionUuid,
  source,
  data,
  modelUuid,
  endpointUuid,
  mappingUuid
}) => {
  const refetchQueries = {
    refetchQueries: [
      {
        query: GetPackageVersionContentInfoDocument,
        variables: {
          versionUuid: packageVersionUuid
        }
      }
    ]
  };
  const [create, { data: createData, loading: createLoading }] = useCreateMockDataMutation(refetchQueries);

  useEffect(() => {
    if (createData) {
      onConfirm();
      setOpenState(false);
    }
  }, [createData]);

  const createModel = (input: CreateEditStructureInput) => {
    create({
      variables: {
        uuid: v4(),
        packageVersionUuid,
        name: input.name,
        description: input.description,
        source,
        data,
        modelUuid,
        endpointUuid,
        mappingUuid
      }
    });
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      description: ''
    },
    validateOnBlur: true,
    validationSchema: CreateStructureInputSchema,
    onSubmit: values => createModel(values)
  });

  // useEffect(() => {
  //   if (editModel) {
  //     const { name, description } = editModel;
  //     formik.setValues({ name: name!, description: description! });
  //   }
  // }, [editModel]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setOpenState(false)}
      label="Save response data"
      title="Optionally provide a name and description"
      closeIcon={<Icon icon="close" />}
      confirmText="Save"
      onConfirm={() => formik.handleSubmit()}
    >
      <form onSubmit={formik.handleSubmit}>
        <EntityNameDescriptionFields
          errors={formik.errors}
          values={formik.values}
          setFieldValue={formik.setFieldValue}
          setFieldTouched={formik.setFieldTouched}
          entity="Mock data"
        />
      </form>
    </Modal>
  );
};
